<template>
  <header
    role="banner"
    :class="['t-header', 't-header--light', { 'location-home': isHomePath }]"
  >
    <router-link
      to="#mainContent"
      class="main-content-link"
      title="跳到主要內容"
      @click.native="reAnchor"
      @keyup.native.enter="reAnchor"
      replace
      >跳到主要內容</router-link
    >
    <AccesskeyLink
      class="accesskey-u accesskey-u--light"
      accesskey="U"
      to="#navigation"
      title="網站主要連結"
      id="navigation"
    />

    <TheNavbar :isHomePath="isHomePath">
      <template #menu>
        <NavigationMenu :isHomePath="isHomePath" />
      </template>
      <template #login v-if="!isFestivalYear">
        <NavigationLogin v-if="isHomePath" />
        <TheSearchbar v-if="!isHomePath" :isHomePath="isHomePath" />
      </template>
    </TheNavbar>

    <router-link
      :to="{ name: 'sitemap' }"
      class="secondary-link"
      aria-label="網站導覽"
      title="[前往]網站導覽"
    >
      網站導覽
    </router-link>
  </header>
</template>

<script>
import NavigationMenu from '@/components/NavigationMenu';
import NavigationLogin from '@/components/NavigationLogin.vue';
import TheSearchbar from '@/components/TheSearchbar';
import TheNavbar from '@/components/TheNavbar';
import AccesskeyLink from '@/components/a11y/AccesskeyLink';

export default {
  name: 'TheHeader',
  props: {
    isHomePath: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    isFestivalYear() {
      return this.$route.meta.isRenderingFestivalTheme;
    },
  },
  methods: {
    // 為了可以重複觸發anchor
    reAnchor() {
      var scrollV,
        scrollH,
        loc = window.location;

      if ('pushState' in history) {
        history.pushState('', document.title, loc.pathname + loc.search);
      } else {
        // Prevent scrolling by storing the page's current scroll offset
        scrollV = document.body.scrollTop;
        scrollH = document.body.scrollLeft;

        loc.hash = '';

        // Restore the scroll offset, should be flicker free
        document.body.scrollTop = scrollV;
        document.body.scrollLeft = scrollH;
      }
    },
  },
  components: {
    TheNavbar,
    NavigationMenu,
    NavigationLogin,
    TheSearchbar,
    AccesskeyLink,
  },
};
</script>

<style lang="scss" scoped>
.t-header {
  border-bottom: 1px solid $color-border;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.85);
  z-index: getLayerIndex(header);
  @include for-tablet {
    box-shadow: 0 -10px 45px 40px $color-bg, 0 15px 50px rgba($color-bg, 0.5);
  }

  @include for-tablet-horizontal {
    border: 0;
    height: 50px;
    box-shadow: 0 0 45px 40px $color-bg, 0 60px 50px rgba($color-bg, 0.5),
      0 90px 50px rgba($color-bg, 0.4);
  }

  @include for-desktop {
    box-shadow: 0 -5px 55px 50px $color-bg, 0 20px 60px rgba($color-bg, 0.5),
      0 30px 80px 50px $color-bg, 0 50px 100px 80px $color-bg,
      0 60px 125px 90px $color-bg;
  }

  &--light {
    border-bottom: 0;
    background: url('../assets/images/header/header_bg.png') center top
      no-repeat;
    background-size: cover;
    /* height: 82px; */
    height: 100px; // TODO: seperate header background section
    box-shadow: none;

    @include for-desktop {
      background: url('../assets/images/header/header_bg_top@3x.png') center top
          no-repeat,
        url('../assets/images/header/header_bg.png') center top no-repeat;
      background-size: 100% 35px, cover;
      box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.4);
    }
  }
}

.secondary-link {
  display: none;
  @extend %secondary-link;

  @include for-desktop {
    display: block;
    position: absolute;
    top: 6px;
    right: 20px;
  }
}

.main-content-link {
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  opacity: 0;

  &:focus,
  &:active {
    opacity: 1;
    top: 6px;
    left: 20px;
    @extend %secondary-link;
  }
}

.accesskey-u {
  position: absolute;
  z-index: 20;
  top: 13px;
  left: 3px;

  &--light {
    top: 50px;
    @include for-desktop {
      top: 58px;
    }
  }
}
</style>
